import type { ReactNode } from 'react';
import { Typography } from '@mui/material';
import { lineClamp } from '@/utils/line-clamp';

interface TitleProps {
  children: React.ReactNode;
  lines?: number;
}

export const Title = ({ children, lines = 3 }: TitleProps) => {
  return (
    <Typography variant="h3" sx={lineClamp(lines)}>
      {children}
    </Typography>
  );
};

export const Subtitle = ({ children }: { children: ReactNode }) => {
  return (
    <Typography variant="body2" color="neutral.500">
      {children}
    </Typography>
  );
};
